import React from 'react'
import {useParams} from 'react-router'
import {Tabs} from 'antd'
import {observer} from 'mobx-react'
import {useStores} from '../../../store'
import {DetailsPageHeader, ErrorComponent, FullLoader} from '../../common'
import {i18n}  from '../../../i18n'
import EditSideEffect from './EditSideEffect'
import GenericTable from '../../tabs/GenericTable'
import {useSimpleGetDelete} from '../../relations/utils/hooks'
import IngredientsTable from '../../ingredient/components/IngredientsTable'

const SideEffectDetails = observer(() => {
    const {sideEffectId} = useParams<{sideEffectId: string}>()

    const {sideEffectStore, ingredientStore} = useStores()
    const {loading, loadingDelete, currentData, onDelete} = useSimpleGetDelete(sideEffectId, sideEffectStore)

    if (loading) {
        return <FullLoader />
    }

    if (!currentData) {
        return <ErrorComponent status={404} title={i18n.t('sideEff.errors.notFound')} />
    }

    return (
        <>
            <DetailsPageHeader
                title={currentData.title}
                onDelete={onDelete}
                messageDelete={i18n.t('sideEff.messages.delete')}
                loadingDelete={loadingDelete}
                data={currentData}
                footer={
                    <Tabs defaultActiveKey='details'>
                        <Tabs.TabPane tab={i18n.t('tabs.details.title')} key='details'>
                            <EditSideEffect sideEffect={currentData} />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={i18n.t('tabs.ingredients.title')} key='ingredients'>
                            <GenericTable
                                getDataServer={async () => ingredientStore.getIngredientsForSideEffect(currentData.id)}
                                skipColumns={['url']}
                                dataTable={IngredientsTable}
                            />
                        </Tabs.TabPane>
                    </Tabs>
                }
            />
        </>
    )
})

export default SideEffectDetails
